<template>
  <div v-if="isShown" class="alert-panel" @click="cancel">
    <div class="alert-panel__modal">
      <div class="alert-panel__header">
        <div class="alert-panel__header-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.527 4.85098L3.23087 17.3485C3.08044 17.6158 3.00085 17.9189 3.00001 18.2275C2.99916 18.5362 3.0771 18.8397 3.22607 19.1078C3.37504 19.376 3.58984 19.5995 3.84911 19.756C4.10838 19.9125 4.40308 19.9967 4.70388 20.0001H19.2961C19.5969 19.9967 19.8916 19.9125 20.1509 19.756C20.4102 19.5995 20.625 19.376 20.7739 19.1078C20.9229 18.8397 21.0008 18.5362 21 18.2275C20.9992 17.9189 20.9196 17.6158 20.7691 17.3485L13.473 4.85098C13.3194 4.59122 13.1032 4.37646 12.8452 4.22741C12.5872 4.07836 12.2961 4.00006 12 4.00006C11.7039 4.00006 11.4128 4.07836 11.1548 4.22741C10.8968 4.37646 10.6806 4.59122 10.527 4.85098Z"
              fill="white"
            />
            <path
              d="M12 9V13.5"
              stroke="#409FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 17.0002H12.0108"
              stroke="#409FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="alert-panel__header-title">
          {{ title }}
          <!--                אזהרה-->
        </div>
        <div class="alert-panel__header-close-btn" @click="cancel">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.3332 4.66669L4.6665 11.3334"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.6665 4.66669L11.3332 11.3334"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div class="alert-panel__body">
        <div class="alert-panel__title">
          <!--                האם אתה בטוח שברצונך למחוק את המשתמש?-->
          {{ question }}
        </div>
      </div>
      <div class="alert-panel__footer">
        <button class="btn btn--blue" @click="confirm">אשר</button>
        <button class="btn btn--border-grey" @click="cancel">בטל</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    question: String,
    title: String,
    isShown: [Boolean, Number]
  },
  mounted() {},
  methods: {
    confirm() {
      this.$emit('ok');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
